import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "line-chart" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Bar Chart</h1><p> To create a bar chart in <b>vue3-charts</b> you can use the <code>Bar</code> layer. You can add the <code>Bar</code> layer multiple times or combine it with other layers (<code>Line</code>, <code>Area</code>). </p><p> If you have multiple <code>Bar</code> layers you can render them stacked or side by side. </p><p> Let&#39;s see a simple example using two <code>Bar</code> layers and a <code>Marker</code> layer. You can change the chart <code>direction</code> to have a column chart </p>", 4)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6" }, "Bar Props", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "The bar layer allows a number of properties to be specified.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Use barStyle to set svg styling for each bar.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Ex:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside" }, [
  /*#__PURE__*/_createElementVNode("li", null, "fill (ex. red)"),
  /*#__PURE__*/_createElementVNode("li", null, "fill-opacity"),
  /*#__PURE__*/_createElementVNode("li", null, "stroke"),
  /*#__PURE__*/_createElementVNode("li", null, "strokeWidth")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Max width for the bar. ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "What data the bar to render.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Ex: "),
  /*#__PURE__*/_createElementVNode("code", null, "['name', 'pl']")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!
  const _component_Prop = _resolveComponent("Prop")!
  const _component_PropsBlock = _resolveComponent("PropsBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BarChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_6,
    _hoisted_7,
    _createVNode(_component_PropsBlock, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_Prop, {
          name: "barStyle",
          types: ['Function', 'Object']
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "maxWidth",
          types: ['Number'],
          odd: ""
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "dataKeys",
          types: ['Array']
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}